<component-modal>
  <ng-container title>
    {{ targetFolder() ? "Create document" : "Create new" }}
  </ng-container>
  <ng-container body>
    @if (!targetFolder()) {
      <div class="types-wrap grid-auto-cols">
        <label class="type" [class.active]="selectedType() === Type.Document">
          <input
            type="radio"
            name="entityType"
            [value]="Type.Document"
            [checked]="selectedType() === Type.Document"
            (change)="selectedType.set(Type.Document)" />
          <custom-icon name="fileText" [size]="28" viewBox="0 0 20 20" />
          <span>Document</span>
        </label>

        <label class="type" [class.active]="selectedType() === Type.Folder">
          <input
            type="radio"
            name="entityType"
            [value]="Type.Folder"
            [checked]="selectedType() === Type.Folder"
            (change)="selectedType.set(Type.Folder)" />
          <custom-icon name="folder" [size]="28" viewBox="0 0 20 20" />
          <span>Folder</span>
        </label>
      </div>
    }

    <component-input
      #nameInput
      label="{{ selectedType() }} Name"
      [formControl]="control"
      [required]="true"
      [errorMessage]="control.hasError('required') && control.touched ? `${selectedType()} name is required` : null"
      (enter)="onSave()" />
  </ng-container>
  <ng-container footer>
    <div class="grid-auto-cols flex-grow-1 gap-3">
      <button type="button" class="btn btn-lg btn-light" (click)="activeModal.close()">Cancel</button>
      <button type="button" class="btn btn-lg btn-primary" (click)="onSave()" [disabled]="control.invalid">Create</button>
    </div>
  </ng-container>
</component-modal>
